// var LoginLink = document.getElementById('modalLoginTrigger');
// var SigninLink = document.getElementById('modalSigninTrigger');
// var ResetPasswordLink = document.getElementById('ResetPasswordTrigger');
// var closeLoginBtn = document.querySelector('#modalLoginClose');
// var closeSigninBtn = document.querySelector('#modalSigninClose');
// var LoginModalTarget = document.getElementById('modalLoginTarget');
// var SigninModalTarget = document.getElementById('modalSigninTarget');
// var ResetPasswordModalTarget = document.getElementById('modalResetPasswordTarget');
// var swithSignin = document.getElementById('swithSignin');

// LoginLink.addEventListener('click', function(e){
//   if (!LoginModalTarget.classList.contains('show')){
//     LoginModalTarget.classList.add('show');
//   } else {
//     LoginModalTarget.classList.remove('show');
//   }
//   e.preventDefault();
// });

// closeLoginBtn.addEventListener('click', function(e){
//   if (LoginModalTarget.classList.contains('show')){
//     LoginModalTarget.classList.remove('show');
//   }
//   e.preventDefault();
// });

// closeSigninBtn.addEventListener('click', function(e){
//   if (SigninModalTarget.classList.contains('show')){
//     SigninModalTarget.classList.remove('show');
//   }
//   e.preventDefault();
// });

// swithSignin.addEventListener('click', function(e){
//   changeModal(LoginModalTarget, SigninModalTarget);
// });

// function changeModal(currentModal, ChangeModal) {
//   currentModal.classList.remove('show');
//   ChangeModal.classList.add('show');
// }

function fadeIn(node, duration) {
  // display: noneでないときは何もしない
  if (getComputedStyle(node).display !== 'none') return;
  
  // style属性にdisplay: noneが設定されていたとき
  if (node.style.display === 'none') {
    node.style.display = '';
  } else {
    node.style.display = 'block';
  }
  node.style.opacity = 0;

  var start = performance.now();
  
  requestAnimationFrame(function tick(timestamp) {
    // イージング計算式（linear）
    var easing = (timestamp - start) / duration;

    // opacityが1を超えないように
    node.style.opacity = Math.min(easing, 1);

    // opacityが1より小さいとき
    if (easing < 1) {
      requestAnimationFrame(tick);
    } else {
      node.style.opacity = '';
    }
  });
}

// var authDrawerTriggers = document.querySelectorAll('.site-header__auth-toggle');
// var authDrawerClose = document.querySelector('.js-auth-drawer-close');

// var LoginFormBtn = document.querySelector('#LoginFormBtn');
// var LoginForm = document.querySelector('#LoginForm');
// var PageLoginForm = document.querySelector('#PageLoginForm');

// var SigninFormBtn = document.querySelector('#SigninFormBtn');
// var SigninForm = document.querySelector('#SigninForm');

// var ResetPasswords = document.querySelectorAll('#ResetPassword');
// var PageResetPasswords = document.querySelectorAll('#PageResetPassword');
// var ResetPasswordForm = document.querySelector('#ResetPasswordForm');
// var PageResetPasswordForm = document.querySelector('#PageResetPasswordForm');

// var PageResetPasswordCancel = document.querySelector('#PageResetPasswordCancel');


// authDrawerTriggers.forEach(function(authDrawerTrigger) {
//   authDrawerTrigger.addEventListener('click', function(e){
//     if (!document.body.classList.contains('js-auth-drawer-open')){
//       document.body.classList.add('js-auth-drawer-open');
//     }
//     e.preventDefault();
//   });
// });

// authDrawerClose.addEventListener('click', function(e){
//   if (document.body.classList.contains('js-auth-drawer-open')){
//     document.body.classList.remove('js-auth-drawer-open');
//   }
//   e.preventDefault();
// });

// LoginFormBtn.addEventListener('click', function(e){
//   if (!LoginForm.classList.contains('active')){
//     LoginFormBtn.classList.add('active');
//     SigninFormBtn.classList.remove('active');
//     SigninForm.style.display = 'none';
//     ResetPasswordForm.style.display = 'none';
//     fadeIn(LoginForm, 400);
//   }
//   e.preventDefault();
// });

// SigninFormBtn.addEventListener('click', function(e){
//   if (!SigninForm.classList.contains('active')){
//     SigninFormBtn.classList.add('active');
//     LoginFormBtn.classList.remove('active');
//     LoginForm.style.display = 'none';
//     ResetPasswordForm.style.display = 'none'; 
//     fadeIn(SigninForm, 400);
//   }
//   e.preventDefault();
// });


// ResetPassword.addEventListener('click', function(e){
//   if (!ResetPasswordForm.classList.contains('active')){
//     LoginFormBtn.classList.remove('active');
//     SigninFormBtn.classList.remove('active');
//     LoginForm.style.display = 'none';
//     SigninForm.style.display = 'none';
//     fadeIn(ResetPasswordForm, 400);
//   }
//   e.preventDefault();
// });

// PageResetPassword.addEventListener('click', function(e){
//   if (!PageResetPasswordForm.classList.contains('active')){
//     PageLoginForm.style.display = 'none';
//     fadeIn(PageResetPasswordForm, 400);
//   }
//   e.preventDefault();
// });

// PageResetPasswordCancel.addEventListener('click', function(e){
//   PageResetPasswordForm.style.display = 'none';
//   fadeIn(PageLoginForm, 400);
//   e.preventDefault();
// });